import axios from 'axios';
import config from '../config';
import { RouteCardTemplateReference } from '../interfaces';

export const getRouteCardTemplates = (): Promise<RouteCardTemplateReference[]> => {
    return axios.get(`${config.API_URL}/route-card-templates`).then((response: any) => {
        return response.data.data.routeCardTemplates;
    });
};
